import type { QueryableSelectOptionItem } from "./queryable-select.type";

import isEqual from "lodash/isEqual";

export const isSameQueryableSelectOptionItem = <Value = unknown>(
  optionA?: QueryableSelectOptionItem<Value>,
  optionB?: QueryableSelectOptionItem<Value>
): boolean => {
  return isEqual(optionA?.value, optionB?.value);
};
